import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useErrorMessage } from '#error-message/useErrorMessage';

import type { DeleteQuizMarkedData } from './quizService';

import { QuizKey } from './keys';
import { QuizService } from './quizService';

export function useDeleteMarkedQuiz(quizId?: string) {
  const queryClient = useQueryClient();
  const deleteMarkedQuiz = useMutation({
    mutationFn: (data: DeleteQuizMarkedData) => QuizService.deleteMarkedQuiz(data).then((response) => response.data),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [QuizKey.QUIZ, quizId],
      });
    },
  });

  const errorMessage = useErrorMessage(deleteMarkedQuiz.error);

  return { ...deleteMarkedQuiz, errorMessage };
}
